import Box from "@mui/material/Box";
import {
  Autocomplete,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { Division } from "../../../models/Division";
import {
  useAddAcheteurMutation,
  useAddSectionMutation,
  useGetDivisionsQuery,
  useGetUsersQuery,
} from "../../../redux/features/cache";
import { User } from "../../../models/User";
import { useAppDispatch } from "../../../redux/store";
import {
  addRequestToSend,
  addRequestsToSend,
} from "../../../redux/features/appStateSlice";
import { RequestToSend } from "../../../models/RequestToSend";
import { Section } from "../../../models/Section";

export interface IFormNewSection {
  setNewSection: any;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function FormNewSection({ setNewSection }: IFormNewSection) {
  const [dirty, setDirty] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [ordre, setOrdre] = useState<number | null>(null);
  const { data: divisions = [] as Division[] } = useGetDivisionsQuery({
    treeView: false,
    includeSections: false,
    plano: false,
  });
  const [division, setDivision] = useState<number>();
  const [addSection] = useAddSectionMutation();
  const [opens, setOpens] = useState<boolean>(false);
  const handleCloses = () => setOpens(false);
  const handleOpens = () => setOpens(true);
  const { data: users = [] as User[] } = useGetUsersQuery({
    fonction: "Acheteur",
    sort: "usr_nom",
    div_num: "",
  });
  const [personName, setPersonName] = useState<string[]>([]);
  const [addAcheteur] = useAddAcheteurMutation();
  const dispatch = useAppDispatch();

  const handleSub = async () => {
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Ajout section ${name}`,
          addSection,
          (addedSection: Section) => {
            if (addedSection.plans_seq) {
              let key = personName.map(
                (e) => users.find((x) => x.usr_nom === e)?.usr_cd
              );
              let addTask = key.map((element) => {
                return new RequestToSend(
                  `Ajout acheteur ${element}`,
                  addAcheteur,
                  () => {},
                  {},
                  { plans_seq: addedSection.plans_seq, usr_cd: element },
                  []
                );
              });
              dispatch(addRequestsToSend(addTask));
              setNewSection(addedSection);
            }
          },
          {},
          {
            plans_nom: name,
            div_num: division,
            plans_ordre: ordre,
          },
          []
        )
      )
    );
  };

  const handleDeletes = async (e: any) => {
    setDirty(true);
    let newPerson = personName.filter((x) => x !== e);
    setPersonName(newPerson);
  };

  const handleChange = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <Box>
      <Box sx={{ display: "flex" }}>
        <TextField
          label="Nom de la section"
          sx={{ m: 1 }}
          onChange={(event) => setName(event.target.value)}
        />
        <Autocomplete
          options={divisions}
          getOptionLabel={(allDiv: Division) =>
            `${allDiv.div_num} ${allDiv.div_nom}`
          }
          onInputChange={async (event) => {
            event?.stopPropagation();
          }}
          sx={{
            width: 300,
            m: 1,
            "& input.Mui-disabled": { WebkitTextFillColor: "Black" },
          }}
          onChange={(e, data) => {
            setDirty(true);
            setDivision(data!.div_num);
          }}
          renderInput={(params) => (
            <TextField
              onClick={(e) => e.stopPropagation()}
              {...params}
              variant="outlined"
              label="Division"
            />
          )}
        />
        <TextField
          type="number"
          sx={{ m: 1 }}
          label="Ordre"
          InputProps={{
            inputProps: {
              min: 0,
            },
          }}
          onChange={(event) => setOrdre(parseInt(event.target.value))}
        />
        <FormControl sx={{ m: 1, width: 600 }}>
          <InputLabel
            id="demo-multiple-name-label"
            sx={{
              backgroundColor: "#ffffff",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
          >
            Acheteur
          </InputLabel>
          <Select
            sx={{
              padding: 0,
              maxHeight: 56,
              "& input.Mui-disabled": { WebkitTextFillColor: "Black" },
            }}
            id="demo-multiple-name"
            open={opens}
            onClose={(e) => {
              e.stopPropagation();
              handleCloses();
            }}
            onOpen={handleOpens}
            multiple
            value={personName}
            onChange={(e) => {
              e.stopPropagation();
              handleChange(e);
              setDirty(true);
            }}
            MenuProps={MenuProps}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip
                    key={value}
                    label={value}
                    onMouseDown={(e) => e.stopPropagation()}
                    onDelete={() => {
                      handleDeletes(value);
                    }}
                    sx={{ WebkitTextFillColor: "black" }}
                  />
                ))}
              </Box>
            )}
          >
            {users.map((name) => (
              <MenuItem
                key={name.usr_nom}
                value={name.usr_nom}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {name.usr_nom}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Tooltip title="Enregistrer">
          <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "6px 28px",
              cursor: "pointer",
            }}
            className={`save-wrapper ${!dirty ? "custom-disabled" : ""}`}
          >
            <span
              className={`k-icon k-font-icon k-i-save k-icon-xl`}
              onClick={handleSub}
            ></span>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
}
